import React from 'react';
import { Star } from 'lucide-react';

const StarRating = ({ value, onChange, label, id }) => {
  return (
    <div>
      <label htmlFor={id} className="block text-sm font-medium text-gray-700 mb-2">
        {label}
      </label>
      <div className="flex gap-2">
        {[1, 2, 3, 4, 5].map((star) => (
          <button
            key={star}
            type="button"
            onClick={() => onChange(star)}
            className="focus:outline-none transition-colors"
          >
            <Star
              className={`w-8 h-8 ${
                star <= value
                  ? 'fill-orange-500 text-orange-500'
                  : 'text-gray-300'
              }`}
            />
          </button>
        ))}
      </div>
      <p className="text-sm text-gray-500 mt-1">Vybráno: {value} / 5</p>
    </div>
  );
};

export default StarRating;
